<template>
  <div>
    <div class="index list" @scroll="onScroll">
      <div class="index-mainBackground">
      </div>
      <div class="container" v-if="qrcode">
        <div class="log">
          <div class="log-inquire">
            <div :class="qrcode.fake ? 'log-error' : 'log-succeed'">
              <img v-if="qrcode.fake" src="../../assets/icon/img_attention@2x.png">
              <img v-else src="../../assets/icon/icon_succeed.png" />
            </div>
            <div class="log-content">
              <span class="log-content-title">第 {{ qrcode.scan_count }} 次查询</span>
              <span class="log-content-subTitle"> {{ qrcode.fake ? '请注意辨别产品' : '您购买的产品是正品' }}</span>
            </div>
          </div>
          <div v-if="qrcode.fake">
            <button class="log-btn" @click="toReport">问题反馈</button>
          </div>
        </div>
        <div class="cards">
          <div class="card">
            <div class="card-line">
              <span class="card-line__label">瓶标串号</span>
              <span class="card-line__content">{{ qrcode.no }}</span>
            </div>
            <div class="card-line">
              <span class="card-line__label">商品</span>
              <span class="card-line__content">{{ qrcode.product.short_name ? qrcode.product.short_name + ' ' +
                qrcode.product.spec :
                qrcode.product.name + ' ' + qrcode.product.spec }}</span>
            </div>
            <div class="card-line">
              <span class="card-line__label">销售门店</span>
              <span class="card-line__content">{{ qrcode.shop_name }}</span>
            </div>
          </div>
        </div>
        <div class="sub">历史查询记录</div>
        <div class="cards">
          <div class="card" v-for="item in scanlist" v-if="scanlist.length > 0">
            <div class="card-line">
              <span class="card-line__label">开瓶地点</span>
              <span class="card-line__content">{{ item.province }}/{{ item.city }}/{{ item.district }}</span>
            </div>
            <div class="card-line">
              <span class="card-line__label">开瓶时间</span>
              <span class="card-line__content">{{ item.created }}</span>
            </div>
          </div>
          <div title="暂无查询记录" img="../../assets/icon/img_zanwu.png" v-else></div>
        </div>
      </div>

      <div class="index-logo">
        <img src="../../assets/img/logo.png">
      </div>
    </div>


    <!-- <div class="bottom-tab">
      <div class="bottom-item" @click="toDraw">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>扫码抽奖</span>
      </div>
      <div class="bottom-item">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>防伪验真</span>
      </div>
      <div class="bottom-item" @click="toCreditStore">
        <img src="../../assets/icon/icon_3_slash.png" />
        <span>积分商城</span>
      </div>
    </div> -->



    <!-- <div v-if="qrcode" class='result-container'>
      <div class="product-wrapper">
        <img :src="qrcode.product.cover">
        <div class="product-detail">
          <p>{{ qrcode.product.short_name ? qrcode.product.short_name : qrcode.product.name }}</p>
          <span>{{ qrcode.product.spec }}</span>
          <div class="intro">{{ qrcode.product.intro }}</div>
        </div>
      </div>
      <!== 防伪信息 ==>
      <div v-if="!qrcode.fake" class="result-wrapper">
        <img src="../../assets/icon/img_approval@2x.png">
        <div class="result-text">
          <p>验证通过</p>
          <span>您购买的商品是正品</span>
          <!== <span v-else>您购买的商品第{{ result.scan_count }}次验证</span> ==>
        </div>
        <!== <div class="receive-button">领取积分</div> ==>
      </div>
      <div v-else class="result-wrapper">
        <img src="../../assets/icon/img_attention@2x.png">
        <div class="result-text">
          <p>防伪码查询次数过多</p>
          <span>请谨防假冒产品 如有疑问请举报</span>
        </div>
        <div class="receive-button disabled" @click="toReport">反馈有奖</div>
      </div>
      <div class="result-detail">
        <p>累计查询</p>
        <span>{{ qrcode.scan_count }}次</span>
      </div>
      <div class="result-detail">
        <p>首次查询</p>
        <span>{{ qrcode.first_scan_time }}</span>
      </div>
      <div class="result-detail">
        <p>查询地点</p>
        <span>{{ qrcode.latest_scan.location }}</span>
      </div>
      <template v-if="!qrcode.awarded && qrcode.product.id !== 9">
        <div class="activity-text">
          <p>扫码有奖</p>
          <span>点击参与活动</span>
        </div>
        <div class="activity-item draw">
          <div class="text">
            <p>您有1次抽奖机会</p>
            <span>扫码验真 抽红包 更有机会获得金项链</span>
          </div>
          <div class="button" @click="toDraw">去抽奖</div>
        </div>
      </template>

<div class="bottom-tab">
  <div class="bottom-item" @click="toDraw">
    <img src="../../assets/icon/icon_3_slash.png" />
    <span>扫码抽奖</span>
  </div>
  <div class="bottom-item">
    <img src="../../assets/icon/icon_3_slash.png" />
    <span>防伪验真</span>
  </div>
  <div class="bottom-item" @click="toCreditStore">
    <img src="../../assets/icon/icon_3_slash.png" />
    <span>积分商城</span>
  </div>
</div>
<van-popup class="mp-popup" v-model="showMp">
  <p>长按二维码关注</p>
  <img src="../../assets/img/img_qrcode.png">
</van-popup>
<div class="friend-link-wrapper">
  <a href="https://ddma.vip">点点二维码</a>
  <a href="http://qumahudong.com">趣码互动</a>
</div>
</div> -->
  </div>
</template>

<script>
import Vue from 'vue'
import Config from '@/config/config'
import { mapGetters } from 'vuex'
import { Toast } from 'vant'
Vue.use(Toast)

export default {
  name: 'Result',
  data() {
    return {
      serial: '',
      showMp: false,
      scanlist: [],
      total: 0,
      page: 1,
      size: 10,
    }
  },
  created() {
    this.serial = this.$route.query.serial
    this.getscanlist()
  },
  computed: {
    ...mapGetters(['userInfo', 'qrcode'])
  },
  methods: {
    toReport() {
      this.$router.push({ name: 'Report' })
    },
    onScroll(event) {
      const { scrollTop, clientHeight, scrollHeight } = event.target;
      // 当滚动到底部时触发加载
      if (scrollTop + clientHeight === scrollHeight) {
        console.log('触发了哈哈哈哈')
        if (this.total > this.page * this.size) {
          this.page += 1
          this.getscanlist()
        }

      }
    },

    toDraw() {
      var path = this.qrcode.activity_url ? this.qrcode.activity_url : '/award'
      // var path = '/award'
      if (!this.userInfo.mobile) {
        Toast('请先绑定手机号')
        this.$router.push({ path: '/user/phone/bind', query: { serial: this.serial } })
      } else {
        this.$router.push({ path: path, query: { serial: this.serial } })
      }
    },

    getscanlist() {
      let that = this;
      let url = `/user/scan/?page=${that.page}&size=${that.size}&qrcode_no=${this.qrcode.no}`
      this.axios.get(url, {
        headers: {
          'x-user-token': that.$store.getters.token,
        }
      }).then(function (res) {
        if (res.data) {
          that.scanlist = that.scanlist.concat(res.data.records)
          that.total = res.data.total
        }
        if (res.data.records.length == 0) that.scanlist = res.data.records
      }).catch(function (error) {
        console.log(error)
      })
    },

    toCreditStore() {
      if (this.userInfo.id) {
        const storeUrl = Config.creditStoreBaseUrl + '/?name=' + this.userInfo.nickname + '&gender=' + this.userInfo.gender +
          '&province=' + this.userInfo.province + '&city=' + this.userInfo.city + '&avatar=' + this.userInfo.avatar +
          '&userCode=' + this.userInfo.openid + '&appId=' + Config.creditStoreAppId + '&phone=' + this.userInfo.mobile
        window.location.href = storeUrl
      } else {
        this.$router.push({ path: '/' })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.index {
  &-mainBackground {
        width: 100vw;
        position: absolute;
        top: 0;
        height: 233px;
        background: linear-gradient(180deg, #FFE09A 0%, #F6F8FA 100%);
        // z-index: -1;
    }
  &-logo {
    // position: absolute;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;
    right: 16px;
    left: 16px;
    bottom: 20px;
    padding-bottom: 20px;

    img {
      padding-top: 20px;
      padding-bottom: 50px;
      width: 120px;
      height: 30px;
    }
  }

  .container {
    position: relative;
    display: flex;
    flex-direction: column;
    margin-left: 16px;
    margin-right: 16px;
  }

  .log {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 80px;
    margin-top: 15px;
    margin-bottom: 15px;
    padding: 20px 16px;
    background: #ffffff;
    border-radius: 16px;
    box-sizing: border-box;

    &-inquire {
      display: flex;
    }

    &-succeed {
      // background: #0CAF60;
      border-radius: 30px;
      margin-right: 20px;

      img {
        width: 40px;
        height: 40px;
      }
    }

    &-error {
      // background: #FF6C69;
      border-radius: 30px;
      margin-right: 20px;

      img {
        width: 40px;
        height: 40px;
      }
    }

    &-btn {
      border-style: none;
      background: rgba(255, 224, 158, 0.49);
      border-radius: 8px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 12px;
      color: #E2AB34;
      line-height: 17px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      padding: 10px 8px;
    }

    &-image {
      width: 40px;
      height: 40px;
      margin-right: 20px;
    }

    &-content {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      font-weight: 400;

      &-title {
        font-size: 14px;
        color: #000000;
      }

      &-subTitle {
        font-size: 12px;
        color: #a0aec0;
      }
    }
  }

  .sub {
    position: relative;
    padding: 14px 0px;
    text-align: center;
    font-size: 14px;
    font-weight: 400;
    color: #718096;
  }

  .cards {
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 16px;
    // margin-top: 16px;

    .card {
      display: flex;
      flex-direction: column;
      gap: 16px;
      padding: 16px;
      background: #FFFFFF;
      border-radius: 16px;

      &-line {
        display: flex;
        justify-content: space-between;
        align-items: center;

        &__label {
          font-size: 14px;
          font-weight: 400;
          color: #718096;
        }

        &__content {
          font-size: 14px;
          font-weight: 500;
          color: #111827;
        }
      }
    }
  }

}




.result-container {
  .product-wrapper {
    height: 115px;
    background-color: #ffffff;
    display: flex;

    img {
      width: 90px;
      height: 90px;
      margin: auto 10px;
    }

    .product-detail {
      padding: 10px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;

      p {
        color: #4a4a4a;
        font-size: 16px;
        font-weight: 400;
      }

      span {
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
      }

      .intro {
        color: #aaaaaa;
        width: 250px;
        line-height: 15px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical; // 因插件问题，webpack打包时不能编译此属性，需这样处理
        /* autoprefixer: on */
      }
    }
  }

  .result-wrapper {
    height: 65px;
    background-color: #ffffff;
    margin: 2px 0;
    padding: 0 15px;
    display: flex;
    align-items: center;

    img {
      width: 40px;
      height: 40px;
    }

    .result-text {
      margin-left: 15px;
      line-height: 18px;

      p {
        color: #747474;
        font-size: 14px;
        font-weight: 600;
      }

      span {
        color: #aaaaaa;
        font-size: 12px;
        font-weight: 400;
      }
    }

    .receive-button {
      width: 80px;
      height: 33px;
      border-radius: 100px;
      background-image: linear-gradient(146deg, #b4ec51 0%, #429321 100%);
      color: #ffffff;
      font-size: 12px;
      font-weight: 600;
      line-height: 33px;
      text-align: center;
      position: absolute;
      right: 15px;
    }

    .disabled {
      background-image: linear-gradient(163deg, #ffb6b1 0%, #ff6d63 100%);
    }
  }

  .result-detail {
    height: 40px;
    background-color: #ffffff;
    margin-bottom: 1px;
    display: flex;
    align-items: center;

    p {
      color: #4a4a4a;
      font-size: 12px;
      font-weight: 400;
      display: inline-block;
      margin: 0 15px;
    }

    span {
      display: inline-block;
      width: 280px;
      color: #747474;
      font-size: 12px;
      font-weight: 400;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }

  .activity-text {
    margin: 15px 0;

    p {
      color: #4a4a4a;
      font-size: 14px;
      font-weight: 600;
      display: inline-block;
      margin: 0 10px 0 20px;
    }

    span {
      color: #747474;
      font-size: 14px;
      font-weight: 400;
    }
  }

  .activity-item {
    width: 350px;
    height: 90px;
    border-radius: 10px;
    margin: 0 auto;
    background-image: linear-gradient(137deg, #fad961 0%, #f76b1c 100%);
    display: flex;
    align-items: center;
    justify-content: space-around;

    .text {
      line-height: 20px;

      p {
        color: #ffffff;
        font-size: 14px;
        font-weight: 600;
      }

      span {
        opacity: 0.8;
        color: #ffffff;
        font-size: 12px;
        font-weight: 400;
      }
    }

    .button {
      width: 81px;
      height: 36px;
      border-radius: 18px;
      background-color: #ffffff;
      color: #fd8549;
      font-size: 14px;
      font-weight: 600;
      line-height: 36px;
      text-align: center;
    }
  }

  .draw {
    background-image: linear-gradient(-32deg, #d52321 0%, #d72a23 100%);
    margin-top: 10px;
  }
}

.list {
  overflow-y: scroll;
  height: 100vh;
}
</style>



// WEBPACK FOOTER //
// src/pages/qrcode/result.vue